import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import PortfolioDashboard from "./components/PortfolioDashboard";
import AdminDashboard from "./components/AdminDashboard";
import LearnMore from "./components/LearnMore";
import PageviewTracker from "./components/PageviewTracker";
import { Toaster } from "./components/ui/toaster";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    // Test backend connection
    const testConnection = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log('Backend connected:', response.data.message);
      } catch (e) {
        console.error('Backend connection error:', e);
      }
    };
    testConnection();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <PageviewTracker />
        <Routes>
          <Route path="/" element={<PortfolioDashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/learn-more" element={<LearnMore />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;